import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from 'react-query';
import axiosInstance from '../../Store/helper/axiosInstance';
import { generateUtmExt } from '../../common/common';
import { DASHBOARD_ALL_DATA } from '../QueryKeys/dashboard.key';
import {
  ALL_SPQ_COMPLETED_LIST,
  ALL_SPQ_LIST,
  LEADERBOARD_DETAILS,
  POLL_COMPLETED_LIST,
  POLL_FEATURED,
  POLL_LIST,
  QUIZ_COMPLETED_LIST,
  QUIZ_FEATURED,
  QUIZ_LIST,
  SPECIALITY_SURVEY,
  SPQ_DETAILS,
  SPQ_FEATURED,
  SPQ_RECENT,
  SURVEY_COMPLETED_LIST,
  SURVEY_FEATURED,
  SURVEY_LIST
} from '../QueryKeys/spq.key';
import useFeedInitialData from '../utils/useFeedInitialData';

const staleTime = 300000;
const cacheTime = 600000;
const fetchFeauredSpq = (category) => {
  let api_url = '';
  if (category == 'all') {
    api_url = 'survey/list?from=0&to=10&type=featured';
  } else {
    api_url = `survey/list?category=${category}&from=0&to=10&type=featured`;
  }
  return axiosInstance.get(api_url);
};
const returnQueryKey = (category) => {
  switch (category) {
    case 'all':
      return SPQ_FEATURED;
    case 'poll':
      return POLL_FEATURED;
    case 'quiz':
      return QUIZ_FEATURED;
    case 'survey':
      return SURVEY_FEATURED;
    default:
      return '';
  }
};
export const useSPQFeatured = (category, isStaleTime = true, onSuccess, onError) => {
  return useQuery(returnQueryKey(category), () => fetchFeauredSpq(category), {
    onSuccess,
    onError,
    select: (response) => response.data.data,
    staleTime: isStaleTime ? staleTime : 0,
    cacheTime: cacheTime
  });
};
export const useSPQRecent = (inView, isStaleTime = true) => {
  return useInfiniteQuery(
    SPQ_RECENT,
    ({ pageParam = 0 }) => axiosInstance.get(`survey/list?from=${pageParam}&to=10`),
    {
      enabled: !!inView,
      staleTime: isStaleTime ? staleTime : 0,
      cacheTime: cacheTime,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length == 10) {
          // console.log(allPages.length);
          return allPages.length * 10;
        } else {
          return undefined;
        }
      }
    }
  );
};
const fetchSurvey = ({ queryKey }) => {
  const id = queryKey[1];
  return axiosInstance.get(`survey/detail?id=${id}${generateUtmExt()}`);
};
export const useSpqDetails = (id, onSuccess, onError, enabled) => {
  const queryClient = useQueryClient();
  return useQuery([SPQ_DETAILS, id], fetchSurvey, {
    initialData: () => {
      const spqFeatured = queryClient
        .getQueryData(SPQ_FEATURED)
        ?.data?.data?.find((_s) => _s.survey_id == id);
      const quizFeatured = queryClient
        .getQueryData(QUIZ_FEATURED)
        ?.data?.data?.find((_s) => _s.survey_id == id);

      const surveyFeatured = queryClient
        .getQueryData(SURVEY_FEATURED)
        ?.data?.data?.find((_s) => _s.survey_id == id);
      const spqDashboard = queryClient
        .getQueryData(DASHBOARD_ALL_DATA)
        ?.data?.data?.find((_s) => _s.survey_id == id);

      const [surveyChannel, surveyUiv3Dashboard] = useFeedInitialData('survey', id);
      const survey =
        spqFeatured ||
        quizFeatured ||
        surveyFeatured ||
        spqDashboard ||
        surveyChannel ||
        surveyUiv3Dashboard;
      if (survey) {
        return { data: { data: [survey] } };
      } else {
        return undefined;
      }
    },
    select: (response) => response.data.data[0],
    onSuccess,
    onError,
    enabled
  });
};
//survey/detail?id=${id}${generateUtmExt()}
const returnSpqListQueryKey = (category) => {
  switch (category) {
    case 'all':
      return ALL_SPQ_LIST;
    case 'poll':
      return POLL_LIST;
    case 'quiz':
      return QUIZ_LIST;
    case 'survey':
      return SURVEY_LIST;
    default:
      return '';
  }
};
export const useSpqList = (category, enabled) => {
  return useInfiniteQuery(
    returnSpqListQueryKey(category),
    ({ pageParam = 0 }) =>
      axiosInstance.get(
        category == 'all'
          ? `survey/list?from=${pageParam}&to=10`
          : `survey/list?category=${category}&from=${pageParam}&to=10`
      ),
    {
      enabled: !!enabled,
      // staleTime: staleTime,
      cacheTime: cacheTime,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length == 10) {
          // console.log(allPages.length);
          return allPages.length * 10;
        } else {
          return undefined;
        }
      }
    }
  );
};

export const useSpqPollList = (enabled) => {
  return useInfiniteQuery(
    POLL_COMPLETED_LIST,
    ({ pageParam = 0 }) =>
      axiosInstance.get(`survey/user_survey_list?category=poll&from=10&to=${pageParam}`),
    {
      enabled: !!enabled,

      cacheTime: cacheTime,
      // select: (res) => res.data?.data ?? []
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length == 10) {
          return allPages.length * 10;
        } else {
          return undefined;
        }
      }
    }
  );
};
export const useSpqQuizList = (enabled) => {
  return useInfiniteQuery(
    QUIZ_COMPLETED_LIST,
    ({ pageParam = 0 }) =>
      axiosInstance.get(`survey/user_survey_list?category=quiz&from=10&to=${pageParam}`),
    {
      enabled: !!enabled,

      cacheTime: cacheTime,
      // select: (res) => res.data?.data ?? []
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length == 10) {
          return allPages.length * 10;
        } else {
          return undefined;
        }
      }
    }
  );
};
export const useSpqSurveyList = (enabled) => {
  return useInfiniteQuery(
    SURVEY_COMPLETED_LIST,
    ({ pageParam = 0 }) =>
      axiosInstance.get(`survey/user_survey_list?category=survey&from=10&to=${pageParam}`),
    {
      enabled: !!enabled,

      cacheTime: cacheTime,
      // select: (res) => res.data?.data ?? []
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length == 10) {
          return allPages.length * 10;
        } else {
          return undefined;
        }
      }
    }
  );
};
export const useSpqAllList = (enabled) => {
  return useInfiniteQuery(
    ALL_SPQ_COMPLETED_LIST,
    ({ pageParam = 0 }) => axiosInstance.get(`survey/user_survey_list?from=10&to=${pageParam}`),
    {
      enabled: !!enabled,

      cacheTime: cacheTime,
      // select: (res) => res.data?.data ?? []
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length == 10) {
          return allPages.length * 10;
        } else {
          return undefined;
        }
      }
    }
  );
};

// SPECIALITY HOOKS
const saveLike = (data) => {
  return axiosInstance.post('knwlg/save_like', data);
};

export const useAddSpecialitySurveyLike = (type_id) => {
  const queryClient = useQueryClient();

  return useMutation(saveLike, {
    onMutate: async (obj) => {
      console.log('RQ MUTATION SAVELIKE', obj);
      const queryKeysArr = [SPECIALITY_SURVEY, type_id];
      const previousData = queryClient.getQueryData(queryKeysArr);

      queryClient.setQueryData(queryKeysArr, (oldQueryData) => {
        return {
          ...oldQueryData,
          data: {
            ...oldQueryData.data,
            data: {
              ...oldQueryData.data.data,
              rating: oldQueryData.data.data.myrating
                ? oldQueryData.data.data.rating - 1
                : oldQueryData.data.data.rating + 1,
              myrating: !oldQueryData.data.data.myrating
            }
          }
        };
      });
      return { previousData };
    },
    onError: (_err, _obj, context) => {},
    onSettled: () => {
      queryClient.invalidateQueries([SPECIALITY_SURVEY, type_id]);
    }
  });
};

export const useLeaderboardDetails = (id, onSuccess, onError) => {
  return useQuery(
    [LEADERBOARD_DETAILS, id],
    () => axiosInstance.get('leaderboard/detail?id=' + id),
    {
      enabled: !!id,
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      select: (response) => {
        let responseData = response.data.data;
        let winners = response?.data?.data?.winners || [];
        let details = response?.data?.data?.detail;
        return { winners, details };
      },
      staleTime: staleTime,
      cacheTime: cacheTime
    }
  );
};
